import React from "react";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import Constants from "../../../configurations/constants";
import DiscoverTransactionSearch from "./TransactionSearch";
import DiscoverTransactionsTable from "./TransactionsTable";
import TransactionDetailsModal from "./TransactionDetailsModal";
import DiscoverApi from "../../../api/DiscoverApi";

class DiscoverTransactionsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tableData: [],
      selectedTransaction: null,
      loading: false,
      pageNum: 0,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pages: 0
    };
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onTransactionRowClick = this.onTransactionRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  onSearchHandler(data, params) {
    this.setState({ loading: true, tableData: [] });
    DiscoverApi.findDiscoverTransactions(data)
      .then(response => {
        let data = response.data;
        //augment the code to pad for ID
        //Set a fake length count
        this.setState({
          pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
          pages: Constants.PAGINATION_OFFSET_INDEX - 1,
          pageNum: Constants.PAGINATION_OFFSET_INDEX - 1
        });

        let totalCount = data.length;

        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;

        if (data.length === 0)
          Toaster.warning("No records found.", "Transactions");

        this.setState({ tableData: data, loading: false, pages: pages });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTIONS_SEARCH}`
        ]);
        this.setState({ loading: false });
      });
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
  }

  onTransactionRowClick(index) {
    this.setState({ loading: true });
    const selectedTransaction = this.state.tableData[index];
    DiscoverApi.findDiscoverTransaction(
      selectedTransaction.transactionReference
    )
      .then(response => {
        let data = response.data;
        this.setState({ selectedTransaction: data, loading: false });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_TRANSACTION_SEARCH}`
        ]);
        this.setState({ loading: false });
      });
  }

  handleCloseModal() {
    this.setState({ selectedTransaction: null });
  }

  render() {
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Search Transactions" />
        <DiscoverTransactionSearch onSearchHandler={this.onSearchHandler} />
        <Divider />
        <DiscoverTransactionsTable
          onRowClick={this.onTransactionRowClick}
          tableData={this.state.tableData}
          loading={this.state.loading}
          paginatedCallback={this.paginateid}
          page={this.state.pageNum}
          pages={this.state.pages}
          onTableChange={this.onTableChange}
        />
        {this.state.selectedTransaction && (
          <TransactionDetailsModal
            onRequestClose={this.handleCloseModal}
            isOpen={this.state.selectedTransaction != null}
            transaction={this.state.selectedTransaction}
          />
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DiscoverTransactionsPage, [Permissions.CREATE_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/discover/newCase/TransactionsPage.js